import React from "react";
import './cusLoader.scss'

const CusLoader = () => {
	return (
		<div className='loader active'>
			<div className='loader--content'>Loading中</div>
		</div>
	);
};

export default CusLoader;
